import classNames from 'classnames';
import { FC } from 'react';

import { ImageFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import GradientBorderCard from '../../../components/GradientBorderCard';
import NewsLetterCardContent from '../../../components/NewsLetterCardContent';

import style from './newsletter-signup-card.module.css';

interface Props {
  darkBackground: boolean;
  description: null | string | undefined;
  image?: ImageFragmentFragment | null;
  marketoFormId: null | string | undefined;
  successMessage?: null | string;
  successUrl?: null | string;
  title: null | string | undefined;
  withSmallTitle?: boolean;
}

const NewsletterSignupCard: FC<Props> = ({
  darkBackground,
  description,
  image,
  marketoFormId,
  successMessage,
  successUrl,
  title,
  withSmallTitle,
}) => (
  <GradientBorderCard
    backgroundColor="black"
    containerClassName={classNames(
      style.card,
      {
        [style.noGradientBorder]: !darkBackground,
      },
    )}
  >
    <div className={style.content}>
      <div className={style.newsletterCardWrapper}>
        <NewsLetterCardContent
          description={description ?? ''}
          marketoFormId={marketoFormId}
          successMessage={successMessage ?? 'Thank you for signing up!'}
          successUrl={successUrl}
          title={title}
          withSmallTitle={withSmallTitle}
        />
      </div>

      {image && (
        <AppImage
          className={style.image}
          fallbackHeight={0}
          fallbackWidth={0}
          image={image}
        />
      )}
    </div>
  </GradientBorderCard>
);

export default NewsletterSignupCard;
